module.exports = __webpack_public_path__ + "img/theme_29.bd053d18.png";